import { render, staticRenderFns } from "./evaTask.vue?vue&type=template&id=b2e9073c&scoped=true&"
import script from "./evaTask.vue?vue&type=script&lang=js&"
export * from "./evaTask.vue?vue&type=script&lang=js&"
import style0 from "./evaTask.vue?vue&type=style&index=0&id=b2e9073c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9073c",
  null
  
)

export default component.exports